module.exports = __webpack_public_path__ + "img/price_list.18532bff.png";